import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["height", "name", "portalId", "refHandlers", "src", "targetWidget"];
let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
import { EmbeddedUIBaseURL } from '../utils/url';
import PortalIdParser from 'PortalIdParser';
import getAppName from '../utils/getAppName';
import { jsx as _jsx } from "react/jsx-runtime";
const FrameStyled = styledWithTheme.iframe(_t || (_t = _`
  border-width: ${0};
  width: 100%;
  height: ${0};
  display: block;
`), ({
  theme
}) => theme.borderWidth['0'], ({
  $height
}) => `${$height}px` || 'auto');
export const Frame = _ref => {
  var _portalId;
  let {
      height,
      name,
      portalId,
      refHandlers = [],
      src,
      targetWidget
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  portalId = (_portalId = portalId) !== null && _portalId !== void 0 ? _portalId : PortalIdParser.get();
  if (!portalId && targetWidget !== 'staticPublic') {
    return /*#__PURE__*/_jsx("p", {
      children: "Portal ID required"
    });
  }
  const parentAppName = getAppName();
  if (!parentAppName) {
    return /*#__PURE__*/_jsx("p", {
      children: "Not hosted in HubSpot app"
    });
  }
  const params = new URLSearchParams({
    parentAppName
  });
  const targetUrl = (() => {
    if (src) {
      const url = new URL(src);
      for (const [key, value] of params.entries()) {
        url.searchParams.append(key, value);
      }
      return url.toString();
    }
    if (targetWidget === 'staticPublic') {
      return `${EmbeddedUIBaseURL}/static?${params.toString()}`;
    }
    return `${EmbeddedUIBaseURL}/${portalId}/${targetWidget}?${params.toString()}`;
  })();
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(FrameStyled, Object.assign({}, rest, {
      $height: height,
      "data-test-id": "embedded-academy-frame",
      name: name,
      ref: r => {
        for (const handler of refHandlers) {
          handler(r);
        }
      },
      src: targetUrl
    }))
  );
};